(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mgb-wish-colours"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mgb-wish-colours')) {
    customElements.define('mgb-wish-colours', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const signal = this.abort.signal;
        const form = this.closest('form');
        if (!form) return;
        const variant = form.querySelector('[name="id"]');
        const mainSubmit = form.querySelector('[data-product-submit]');
        const valueBox = this.querySelector('[data-bucket-value]');
        const shippingStatus = this.querySelector('[data-shipping-status]');
        const sticky = this.querySelector('[data-mobile-sticky]');
        const stickyPrice = this.querySelector('[data-sticky-price]');
        const stickySubmit = this.querySelector('[data-sticky-submit]');
        const quantities = (this.dataset.quantityValues || '').split('|').filter(Boolean);

        const sync = () => {
          const option = variant?.selectedOptions?.[0];
          const title = option?.textContent || '';
          const bucketNumber = Number(title.match(/\d+/)?.[0] || 1);
          const quantity = quantities[bucketNumber - 1];
          if (valueBox && quantity) {
            valueBox.textContent = this.dataset.quantityMode === 'approximately'
              ? `Includes approximately ${quantity} gifts, plus possible Wish Colour bonuses.`
              : `Includes at least ${quantity} gifts, plus possible Wish Colour bonuses.`;
          }
          const priceText = option?.dataset.price || '';
          if (stickyPrice) stickyPrice.textContent = priceText;
          const numericPrice = Number(priceText.replace(/[^0-9.]/g, ''));
          if (shippingStatus) {
            shippingStatus.textContent = numericPrice >= 39.99
              ? '✓ This option qualifies for free shipping'
              : 'This option ships for $5.99';
          }
        };

        variant?.addEventListener('change', sync, { signal });
        stickySubmit?.addEventListener('click', () => form.requestSubmit(mainSubmit), { signal });
        if (mainSubmit && sticky && 'IntersectionObserver' in window) {
          const observer = new IntersectionObserver(entries => {
            sticky.hidden = entries[0]?.isIntersecting !== false;
          }, { threshold: 0.15 });
          observer.observe(mainSubmit);
          signal.addEventListener('abort', () => observer.disconnect(), { once: true });
        }
        sync();
      }
      disconnectedCallback() { this.abort?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
